// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-page {
  max-width: 64rem;
  margin: 0 auto;
  padding: 2.25rem 1.5rem 4rem;
}

.contact-head {
  display: grid;
  gap: 0.6rem;
  max-width: 44rem;
  margin-bottom: 2.25rem;
}

.contact-head h1,
.contact-head p {
  margin: 0;
}

.contact-head p {
  font-size: 1.08rem;
}

.contact-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.25fr);
  gap: 2.5rem;
  align-items: start;
}

.contact-before {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 0.6rem;
}

.contact-before h2 {
  margin: 0;
  font-size: clamp(1.3rem, 3vw, 1.6rem);
}

.contact-before .help-guide-list {
  border-top: 1px solid var(--border-primary);
}

.contact-all-help {
  margin: 0.4rem 0 0;
}

.contact-form-wrap {
  padding: clamp(1rem, 3vw, 1.75rem);
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  --note-ground: var(--bg-secondary);
}

.contact-form {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 1.1rem;
}

.form-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 12rem), 1fr));
  gap: 1.1rem;
}

.form-field {
  display: grid;
  gap: 0.35rem;
  min-width: 0;
}

.form-field label {
  font-family: var(--font-mono);
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--text-secondary);
}

.form-field input,
.form-field textarea {
  width: 100%;
  background: var(--bg-primary);
}

.form-field textarea {
  resize: vertical;
  min-height: 8rem;
}

.form-hint {
  font-size: 0.85rem;
  color: var(--text-tertiary);
}

.form-error {
  margin: 0;
  padding: 0.6rem 0.8rem;
  border: 1px solid var(--error);
  color: var(--error);
  font-size: 0.92rem;
}

.contact-submit {
  justify-self: start;
}

.contact-hp {
  position: absolute;
  left: -9999px;
  width: 1px;
  height: 1px;
  opacity: 0;
}

.contact-success {
  display: grid;
  gap: 0.75rem;
  justify-items: start;
}

.contact-success h2 {
  margin: 0;
}

@media (max-width: 820px) {
  .contact-layout {
    grid-template-columns: minmax(0, 1fr);
  }

  .contact-form-wrap {
    order: -1;
  }
}

@media (max-width: 680px) {
  .contact-page {
    padding: 1.5rem 1rem 3rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ContactPage.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uDAAuD;EACvD,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,SAAS;EACT,qCAAqC;AACvC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,+BAA+B;EAC/B,uCAAuC;EACvC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sEAAsE;EACtE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;;EAEE,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".contact-page {\r\n  max-width: 64rem;\r\n  margin: 0 auto;\r\n  padding: 2.25rem 1.5rem 4rem;\r\n}\r\n\r\n.contact-head {\r\n  display: grid;\r\n  gap: 0.6rem;\r\n  max-width: 44rem;\r\n  margin-bottom: 2.25rem;\r\n}\r\n\r\n.contact-head h1,\r\n.contact-head p {\r\n  margin: 0;\r\n}\r\n\r\n.contact-head p {\r\n  font-size: 1.08rem;\r\n}\r\n\r\n.contact-layout {\r\n  display: grid;\r\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1.25fr);\r\n  gap: 2.5rem;\r\n  align-items: start;\r\n}\r\n\r\n.contact-before {\r\n  display: grid;\r\n  grid-template-columns: minmax(0, 1fr);\r\n  gap: 0.6rem;\r\n}\r\n\r\n.contact-before h2 {\r\n  margin: 0;\r\n  font-size: clamp(1.3rem, 3vw, 1.6rem);\r\n}\r\n\r\n.contact-before .help-guide-list {\r\n  border-top: 1px solid var(--border-primary);\r\n}\r\n\r\n.contact-all-help {\r\n  margin: 0.4rem 0 0;\r\n}\r\n\r\n.contact-form-wrap {\r\n  padding: clamp(1rem, 3vw, 1.75rem);\r\n  background: var(--bg-secondary);\r\n  border: 1px solid var(--border-primary);\r\n  --note-ground: var(--bg-secondary);\r\n}\r\n\r\n.contact-form {\r\n  display: grid;\r\n  grid-template-columns: minmax(0, 1fr);\r\n  gap: 1.1rem;\r\n}\r\n\r\n.form-row {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(min(100%, 12rem), 1fr));\r\n  gap: 1.1rem;\r\n}\r\n\r\n.form-field {\r\n  display: grid;\r\n  gap: 0.35rem;\r\n  min-width: 0;\r\n}\r\n\r\n.form-field label {\r\n  font-family: var(--font-mono);\r\n  font-size: 0.72rem;\r\n  font-weight: 600;\r\n  letter-spacing: 0.08em;\r\n  text-transform: uppercase;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.form-field input,\r\n.form-field textarea {\r\n  width: 100%;\r\n  background: var(--bg-primary);\r\n}\r\n\r\n.form-field textarea {\r\n  resize: vertical;\r\n  min-height: 8rem;\r\n}\r\n\r\n.form-hint {\r\n  font-size: 0.85rem;\r\n  color: var(--text-tertiary);\r\n}\r\n\r\n.form-error {\r\n  margin: 0;\r\n  padding: 0.6rem 0.8rem;\r\n  border: 1px solid var(--error);\r\n  color: var(--error);\r\n  font-size: 0.92rem;\r\n}\r\n\r\n.contact-submit {\r\n  justify-self: start;\r\n}\r\n\r\n.contact-hp {\r\n  position: absolute;\r\n  left: -9999px;\r\n  width: 1px;\r\n  height: 1px;\r\n  opacity: 0;\r\n}\r\n\r\n.contact-success {\r\n  display: grid;\r\n  gap: 0.75rem;\r\n  justify-items: start;\r\n}\r\n\r\n.contact-success h2 {\r\n  margin: 0;\r\n}\r\n\r\n@media (max-width: 820px) {\r\n  .contact-layout {\r\n    grid-template-columns: minmax(0, 1fr);\r\n  }\r\n\r\n  .contact-form-wrap {\r\n    order: -1;\r\n  }\r\n}\r\n\r\n@media (max-width: 680px) {\r\n  .contact-page {\r\n    padding: 1.5rem 1rem 3rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
